import { TransactionStatuses } from '../../apis/graphql/types';
import { Option } from '../../components/types';
import { StatusColor } from './statusColor';

const DisplayedTransactionStatuses = {
  Pending: 'Pending',
  Failed: 'Failed',
  Success: 'Success',
  Refunded: 'Refunded',
} as const;

export const transactionStatusColors = {
  [DisplayedTransactionStatuses.Pending]: StatusColor.GRAY,
  [DisplayedTransactionStatuses.Failed]: StatusColor.RED,
  [DisplayedTransactionStatuses.Success]: StatusColor.GREEN,
  [DisplayedTransactionStatuses.Refunded]: StatusColor.BLUE,
};

export const transactionStatusToDisplayMap = {
  [TransactionStatuses.Initiated]: DisplayedTransactionStatuses.Pending,
  [TransactionStatuses.CustomerFailed]: DisplayedTransactionStatuses.Failed,
  [TransactionStatuses.SystemFailed]: DisplayedTransactionStatuses.Failed,
  [TransactionStatuses.Success]: DisplayedTransactionStatuses.Success,
  [TransactionStatuses.Refunded]: DisplayedTransactionStatuses.Refunded,
  [TransactionStatuses.Chargeback]: DisplayedTransactionStatuses.Failed,
  [TransactionStatuses.ChargebackReversed]: DisplayedTransactionStatuses.Success,
  [TransactionStatuses.RefundFailed]: DisplayedTransactionStatuses.Failed,
  [TransactionStatuses.RefundedReversed]: DisplayedTransactionStatuses.Success,
  [TransactionStatuses.RefundInitiated]: DisplayedTransactionStatuses.Success,
};

export const transactionStatusToInternalMap = new Array<Option<Array<TransactionStatuses>>>();
transactionStatusToInternalMap.push({
  label: DisplayedTransactionStatuses.Pending,
  value: [TransactionStatuses.Initiated],
});
transactionStatusToInternalMap.push({
  label: DisplayedTransactionStatuses.Failed,
  value: [
    TransactionStatuses.CustomerFailed,
    TransactionStatuses.SystemFailed,
    TransactionStatuses.Chargeback,
    TransactionStatuses.RefundFailed,
  ],
});
transactionStatusToInternalMap.push({
  label: DisplayedTransactionStatuses.Refunded,
  value: [TransactionStatuses.Refunded],
});
transactionStatusToInternalMap.push({
  label: DisplayedTransactionStatuses.Success,
  value: [
    TransactionStatuses.Success,
    TransactionStatuses.ChargebackReversed,
    TransactionStatuses.RefundedReversed,
    TransactionStatuses.RefundInitiated,
  ],
});
